import { combineReducers } from 'redux';
import auth from './auth';
import distributor from './distributor';
import distributorUser from './distributorUser';
import driver from './driver';
import freight from './freight';
import mapping from './mapping';
import reasonRefusal from './reasonRefusal';
import tables from './tables';
import user from './user';
import vehicleType from './vehicleType';
import deliveryEvents from './deliveryEvents';

export default combineReducers({
  user,
  auth,
  tables,
  distributor,
  freight,
  mapping,
  driver,
  vehicleType,
  reasonRefusal,
  distributorUser,
  deliveryEvents,
});
